import { render, staticRenderFns } from "./user-agreement-for-algo-data.html?vue&type=template&id=f9511f36&scoped=true&external"
import script from "./user-agreement-for-algo-data.js?vue&type=script&lang=js&external"
export * from "./user-agreement-for-algo-data.js?vue&type=script&lang=js&external"
import style0 from "./user-agreement-for-algo-data.scss?vue&type=style&index=0&id=f9511f36&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9511f36",
  null
  
)

export default component.exports